import { Box, Flex, Icon, Text } from '@chakra-ui/react';
import {
  CheckCircleIcon,
  ExclamationCircleIcon,
  InformationCircleIcon,
  ExclamationIcon
} from '@heroicons/react/solid';

type Props = {
  type: 'Danger' | 'Info' | 'Success' | 'Warning';
  body: any; // TODO: remove `any`
};

export function Callout({ type, body }: Props) {
  const secondaryBlue = `primary.500`;

  const iconSwitch = () => {
    switch (type) {
      case 'Danger':
        return { icon: ExclamationCircleIcon, color: 'red.500' };
      case 'Warning':
        return { icon: ExclamationIcon, color: 'yellow.500' };
      case 'Success':
        return { icon: CheckCircleIcon, color: 'green.500' };
      case 'Info':
        return { icon: InformationCircleIcon, color: secondaryBlue };
      default:
        return { icon: InformationCircleIcon, color: secondaryBlue };
    }
  };

  const borderSwitch = () => {
    switch (type) {
      case 'Danger':
        return { color: 'red.500' };
      case 'Warning':
        return { color: 'yellow.500' };
      case 'Success':
        return { color: 'green.500' };
      case 'Info':
        return { color: secondaryBlue };
      default:
        return { color: secondaryBlue };
    }
  };

  const { icon, color: iconColor } = iconSwitch();
  const { color: borderColor } = borderSwitch();

  return (
    <Flex
      justify="center"
      align={'center'}
      px={6}
      py={4}
      my={6}
      bg={'background'}
      gap={2}
      rounded="md"
      borderLeft="solid 4px"
      borderColor={borderColor}
    >
      <Icon as={icon} color={iconColor} boxSize={5} pos="relative" />
      <Box w="full">
        <Text color="white">{body}</Text>
      </Box>
    </Flex>
  );
}
